"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Target } from "lucide-react";
export default function TheAdvancementPhilosophy() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="the-advancement-philosophy" className="dark bg-background text-foreground relative overflow-hidden border-y border-border/40">
      {}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-primary/5 skew-x-[-45deg] translate-x-1/4 pointer-events-none" />
      <div className="absolute bottom-0 left-1/2 w-px h-32 bg-gradient-to-t from-primary/50 to-transparent pointer-events-none" />

      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh]">
        {}
        <div className="relative min-h-[50vh] lg:min-h-full overflow-hidden group">
          <div className="absolute inset-0 bg-background/20 z-10 mix-blend-overlay transition-opacity duration-700 group-hover:opacity-0" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575279/img/coach_player_discussion_bw.png" alt="Coach and player mid-discussion on the ice" className="absolute inset-0 w-full h-full object-cover grayscale contrast-[1.3] brightness-90 transition-transform duration-1000 group-hover:scale-105" />
          {}
          <div className="absolute bottom-0 right-0 w-32 h-32 bg-background z-20 clip-path-triangle-bottom-right hidden lg:block" style={{
          clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
        }} />
        </div>

        {}
        <div className="relative flex flex-col justify-center p-8 md:p-16 lg:p-20 xl:p-24 z-20 bg-background/95 backdrop-blur-sm lg:bg-transparent lg:backdrop-blur-none">
          <div ref={contentRef} className={`max-w-2xl transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-3 mb-6">
              <Target className="w-6 h-6 text-primary" />
              <span className="text-sm font-mono tracking-widest text-primary uppercase">
                Core Principles
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter uppercase mb-8 text-foreground flex flex-col gap-2">
              <span>The DB</span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-foreground to-muted-foreground">
                Method
              </span>
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-loose font-serif">
              <p>
                At DB Hockey Advancement, we believe that reaching the next level requires more than just raw talent. It demands a calculated, relentless approach to development, both on and off the ice.
              </p>
              <p>
                Our philosophy is rooted in personalized mentorship and comprehensive evaluation. We don't just see a player; we see a prospect with a unique pathway to junior or college hockey. By combining elite skill development with strategic scouting and recruitment assistance, we bridge the gap between potential and performance.
              </p>
              <p>
                Success isn't an accident. It's a byproduct of the right guidance, the right exposure, and an unwavering commitment to the grind.
              </p>
            </div>

            <div className="mt-12 pt-10 border-t border-border/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
              <div className="flex flex-col gap-2">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575279/img/alex_johnson_signature.png" alt="Alex Johnson Signature" className="h-14 object-contain invert opacity-90" />
                <div className="flex flex-col">
                  <span className="font-bold text-foreground tracking-wide uppercase text-sm">Charles-Anthony Barbeau</span>
                  <span className="text-xs text-muted-foreground font-mono uppercase tracking-wider">Advisor &amp; co-Founder</span>
                </div>
              </div>

              <Button asChild variant="outline" size="lg" className="rounded-none border-primary/50 hover:bg-primary hover:text-primary-foreground transition-colors duration-300">
                <Link to="/OurProcessPage">
                  Explore Our Process
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}